import reduceReducers from 'reduce-reducers';

import * as ActionTypes from '../constants/reduxConstants.js';
import { namespaceReducer } from '../utils/namespace-redux';
import foldersReducer, { initialState as foldersInitialState } from './folders';

const initialState = {
  ...foldersInitialState,
  name: '',
  blurb: 'Hi! I <3 CS',
  image: 'https://placekitten.com/300/300',
  type: ''
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_PROFILE: {
      return {
        ...state,
        name: action.data.name,
        type: action.data.type,
        image: action.data.image,
        blurb: action.data.blurb,
      };
    }

    default:
      return state;
  }
};

export default reduceReducers(
  profile,
  namespaceReducer(foldersReducer, 'PROFILE_FOLDERS')
);
